export type DataSource = 'deterministic' | 'semantic' | 'manual'

export type IngestSourceKind = 'pid' | 'sop' | 'diagram' | 'manual' | 'deterministic'

export interface Evidence {
  id: string
  source: DataSource
  source_kind: string
  source_file?: string
  confidence: number
  created_by?: string
  created_at: string
  model_version?: string
  source_page?: number
  source_region?: string
  source_excerpt?: string
  extraction_method?: string
}

export interface EvidenceItem {
  source_file: string
  source_page?: number
  source_excerpt?: string
  confidence: number
  extraction_model: string
  extracted_at: string
}

export interface Provenance {
  source_file?: string
  source_kind?: string
  source_page?: number
  source_region?: string
  source_excerpt?: string
  extraction_model?: string
  extraction_method?: string
  confidence?: number
  evidence_items?: EvidenceItem[]
  last_evidence_at?: string
  evidence: Record<string, Evidence>
}

export const REQUIRED_PROVENANCE_FIELDS = [
  'source_file',
  'source_kind',
  'source_page',
  'source_region',
  'source_excerpt',
  'extraction_model',
  'extraction_method',
  'confidence',
  'evidence_items',
  'last_evidence_at'
] as const satisfies readonly (keyof Provenance)[]

export type ConflictSeverity = 'info' | 'warning' | 'error'

export type ConflictResolution = 'keep_existing' | 'accept_incoming' | 'flag_for_review'

export interface ProvenanceConflict {
  node_id?: string
  node_label?: string
  property: string
  existing_value: unknown
  existing_source: DataSource
  incoming_value: unknown
  incoming_source: DataSource
  severity: ConflictSeverity
  suggested_resolution: ConflictResolution
  message: string
}

export interface CreateEvidenceOptions {
  source: DataSource
  source_kind: string
  confidence: number
  source_file?: string
  created_by?: string
  model_version?: string
  source_page?: number
  source_region?: string
  source_excerpt?: string
  extraction_method?: string
  extraction_model?: string
  extracted_at?: string
}

export interface CreateIngestProvenanceOptions {
  source_file: string
  source_kind: IngestSourceKind
  source_page?: number
  source_region?: string
  source_excerpt?: string
  extraction_model: string
  extraction_method: string
  confidence: number
  extracted_at?: string
}

export interface ProvenanceValidationResult {
  valid: boolean
  errors: string[]
}
